"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isLocalStorageAvailable = function () {
    try {
        var testKey = 'test';
        window.localStorage.setItem(testKey, testKey);
        window.localStorage.removeItem(testKey);
        return true;
    }
    catch (e) {
        return false;
    }
};
var LocalStorage = {
    getItem: function (key) {
        if (!isLocalStorageAvailable()) {
            return null;
        }
        try {
            return window.localStorage.getItem(key);
        }
        catch (e) {
            console.error("Error getting item from localStorage: " + e);
            return null;
        }
    },
    setItem: function (key, value) {
        if (!isLocalStorageAvailable()) {
            return null;
        }
        try {
            window.localStorage.setItem(key, value);
            return true;
        }
        catch (e) {
            console.error("Error setting item in localStorage: " + e);
            return false;
        }
    },
    removeItem: function (key) {
        if (!isLocalStorageAvailable()) {
            return null;
        }
        try {
            window.localStorage.removeItem(key);
            return true;
        }
        catch (e) {
            console.error("Error removing item from localStorage: " + e);
            return false;
        }
    }
};
exports.default = LocalStorage;
